<div id='thank-you'>

	<div class='heading-block' *ngIf='formService.aboutToRedirect'>
		<div class='only-inner-container'>
			<div class='inner-content'>
				<div class='title'>🎉 <ng-container i18n>Success! Redirecting to your Personal Dashboard...</ng-container></div>
				<div class='text' i18n>In a few seconds you will be redirected. If you don't wish to wait, please click below:</div>
				<div class='button-position'>
					<a *ngIf='!loadingAnimationBeforeRedirecting' class='button' (click)='waitAndGoToDashboard($event)' href='{{formService.dashboardUrl}}' i18n>Go to Dashboard</a>
					<div *ngIf='loadingAnimationBeforeRedirecting' class='loader'>
						<div class='loader-spinner'></div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class='heading-block' *ngIf='!formService.aboutToRedirect && formService.failSafeMessage'>
		<div class='only-inner-container'>
			<div class='inner-content'>
				<div class='title' i18n>🎉 The moving companies will start reaching out to you within one working day.</div>
			</div>
		</div>
	</div>

	<!-- Only shown when needed -->
	<div class='extras-block' *ngIf='formService.questionsActive'>
		<form id='third-party-questions-form' class='questions-form form-body steps-amount-{{formService.totalThirdPartyStepsAmount}}' [formGroup]='thirdPartyForm'>
			<div class='form-steps' [@slide]="formService.currentThirdPartyStep">
				<app-choose-services
					[style.display]='formService.shouldShowThirdParty("choose_services") ? "flex" : "none"'>
				</app-choose-services>

				<app-currency-exchange
					[style.display]='formService.shouldShowThirdParty("currency_exchange") ? "flex" : "none"'
					*ngIf="formService.visibleThirdPartyServices.includes('currency_exchange')">
				</app-currency-exchange>

				<app-health-insurance 
					[style.display]='formService.shouldShowThirdParty("health_insurance") ? "flex" : "none"'
					*ngIf="formService.visibleThirdPartyServices.includes('health_insurance')">
				</app-health-insurance>

				<app-real-estate
					[style.display]='formService.shouldShowThirdParty("real_estate") ? "flex" : "none"'
					*ngIf="formService.visibleThirdPartyServices.includes('real_estate')">
				</app-real-estate>

				<app-utilities 
					[style.display]='formService.shouldShowThirdParty("utilities") ? "flex" : "none"'
					*ngIf="formService.visibleThirdPartyServices.includes('utilities')">
				</app-utilities>
			</div>
		</form>
	</div>

</div>